<template>
  <b-modal
    v-model="showWarning"
    title="Session Timeout Warning"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    :hide-header-close="true"
    centered
    size="sm"
    @hidden="handleModalClose"
  >
    <div class="text-center">
      <feather-icon
        icon="ClockIcon"
        size="60"
        class="text-warning mb-2 mt-2"
      />
      <h3 class="mb-1">
        Session Expiring Soon
      </h3>
      <p class="mb-3">
        You’ve been inactive for a while. For your security, you’ll be logged out soon unless you resume activity.
      </p>

      <p class="font-weight-bold text-danger countdown">
        00:{{ countdown.toString().padStart(2, '0') }}
      </p>
      <p class="small text-muted mt-4">
        Click "Stay Logged In" to keep your session active.
      </p>
    </div>

    <template #modal-footer>
      <div class="w-100 d-flex justify-content-center align-items-center">
        <b-button
          variant="outline-secondary"
          class="mr-2"
          @click="logout"
        >
          Logout Now
        </b-button>
        <b-button
          variant="primary"
          @click="stayLoggedIn"
        >
          Stay Logged In
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'
import { toastAlert } from '@core/mixins/toast'
import inactivityManager from '@/utils/inactivityManager'

export default {
  name: 'InactivityWarning',
  components: {
    BModal,
    BButton,
  },
  mixins: [toastAlert],
  data() {
    return {
      showWarning: false,
      countdown: 60,
      countdownInterval: null,
    }
  },

  beforeDestroy() {
    this.stopCountdown()
  },
  methods: {
    show() {
      if (this.isAuthPage()) {
        return
      }
      this.showWarning = true
      this.countdown = 60
      this.startCountdown()
    },

    hide() {
      this.showWarning = false
      this.stopCountdown()
    },

    isAuthPage() {
      const route = this.$route
      const meta = route.meta || {}
      return (
        (meta.layout === 'full' && meta.resource === 'Auth')
        || route.path.includes('/error-')
        || route.path.includes('/miscellaneous/')
        || meta.requiresAuth === false
        || meta.redirectIfLoggedIn === true
      )
    },

    startCountdown() {
      this.countdownInterval = setInterval(() => {
        this.countdown -= 1
        if (this.countdown <= 0) {
          // Only logout when countdown reaches zero - message will be handled by the logout handler
          this.logout()
        }
      }, 1000)
    },

    stopCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval)
        this.countdownInterval = null
      }
    },

    stayLoggedIn() {
      this.hide()
      // This will dismiss warning across all tabs and reset timer
      inactivityManager.dismissWarning()
      this.$emit('stay-logged-in')
    },

    logout() {
      this.hide()

      // This will trigger logout across ALL tabs
      inactivityManager.handleInactivityLogout()
    },

    handleModalClose() {
      this.stopCountdown()
    },
  },
}
</script>

<style lang="scss" scoped>
.countdown {
  font-weight: bold;
  font-size: 4rem;
}
.seconds {
  font-size: 1rem;
  font-weight: normal;
}
</style>
